import { render, staticRenderFns } from "./Zeitraumliste.vue?vue&type=template&id=ff066218&scoped=true"
import script from "./Zeitraumliste.vue?vue&type=script&lang=js"
export * from "./Zeitraumliste.vue?vue&type=script&lang=js"
import style0 from "./Zeitraumliste.vue?vue&type=style&index=0&id=ff066218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff066218",
  null
  
)

export default component.exports